import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { ConfigProvider } from 'antd-mobile';
import zhCN from 'antd-mobile/es/locales/zh-CN';
import { useEffect } from 'react';
import { useAuthStore, bootstrapAuth } from './stores/authStore';

// 页面
import LoginPage from './pages/LoginPage';
import HomePage from './pages/HomePage';
import TicketListPage from './pages/TicketListPage';
import TicketCreatePage from './pages/TicketCreatePage';
import TicketDetailPage from './pages/TicketDetailPage';
import ProfilePage from './pages/ProfilePage';
import SettingsPage from './pages/SettingsPage';
import MobileLayout from './components/MobileLayout';

// 权限守卫
function AuthGuard({ children, roles }: { children: React.ReactNode; roles?: string[] }) {
  const { user, isLoggedIn } = useAuthStore();
  
  if (!isLoggedIn) return <Navigate to="/login" replace />;
  if (roles && !roles.includes(user!.role)) return <Navigate to="/" replace />;
  
  return <>{children}</>;
}

export default function App() {
  // 从 localStorage 恢复登录态
  useEffect(() => { bootstrapAuth(); }, []);
  return (
    <ConfigProvider locale={zhCN}>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route element={<MobileLayout />}>
            <Route path="/" element={<HomePage />} />
            <Route path="/tickets" element={
              <AuthGuard><TicketListPage /></AuthGuard>
            } />
            <Route path="/tickets/new" element={
              <AuthGuard roles={['inspector', 'admin']}><TicketCreatePage /></AuthGuard>
            } />
            <Route path="/tickets/:id" element={
              <AuthGuard><TicketDetailPage /></AuthGuard>
            } />
            <Route path="/profile" element={
              <AuthGuard><ProfilePage /></AuthGuard>
            } />
            <Route path="/settings" element={
              <AuthGuard><SettingsPage /></AuthGuard>
            } />
          </Route>
          <Route path="*" element={<div>404</div>} />
        </Routes>
      </BrowserRouter>
    </ConfigProvider>
  );
}